module.exports = __webpack_public_path__ + "static/media/1_04.0c603469.png";